export const cleanData = <T extends Record<string, any>>(data: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(data).filter(
      ([, value]) =>
        value !== null &&
        value !== undefined &&
        value !== '' &&
        !Number.isNaN(value),
    ),
  ) as Partial<T>;
